export type DefaultFields = {
  instant: false;
  titl: string;
};

type BookAppointmentRequestAnywhereFields = {
  apptReasonId: string;
  locationId: string;
  patientId: string;
  practiceId: string;
  slotIds: string[];
  specialtyId: string;
};

type BookAppointmentVirtualFields =
  | {claimedUsStateByPatient: string; virtual: true}
  | {claimedUsStateByPatient?: string; virtual: false};

type RescheduleAppointmentFields = {
  reschedulingApptId: string;
};

export type BookAppointmentRequest = BookAppointmentRequestAnywhereFields &
  BookAppointmentVirtualFields &
  Partial<DefaultFields>;

export type RescheduleAppointmentRequest = BookAppointmentRequest & RescheduleAppointmentFields;

export const isRescheduleRequest = (
  request: BookAppointmentRequest | RescheduleAppointmentRequest,
): request is RescheduleAppointmentRequest =>
  "reschedulingApptId" in request && typeof request.reschedulingApptId === "string";

export type RescheduledAppointmentResponse =
  | {
      booking: BookedAppointment;
      bookingError: undefined;
      cancelled?: Response;
      cancelledError?: unknown;
    }
  | {
      booking: undefined;
      bookingError: unknown;
      cancelled?: Response;
      cancelledError?: unknown;
    };

export type BookAppointmentResponse =
  | {
      booking: BookedAppointment;
      bookingError: undefined;
    }
  | {
      booking: undefined;
      bookingError: unknown;
    };

export type BookedAppointment = {
  apptReasonId?: string;
  apptResponsibleParty: AppointmentResponsibleParty;
  apptSignOffs: unknown[];
  apptSpecialty: AppointmentSpecialty;
  autoCancelWarningStatus: string;
  billIds: unknown[];
  caseId: string;
  caseIds: string[];
  claimedUsStateByPatient?: string;
  dayBeforeNotification: string;
  doctorNotification: string;
  elCaminoFetchAttempted?: boolean;
  entityOrderStatus: string;
  externalId: number;
  feedbackEmailStatus: string;
  hasBillables: boolean;
  hpiStatus: string;
  hxReviewed: boolean;
  id: string;
  inHouseLabRequestStatus: string;
  installNotification: string;
  instant: boolean;
  justBeforeNotification: string;
  labRequestStatus: string;
  medicalImageRequestStatus: string;
  patientHasSigned: boolean;
  patientId: string;
  rxStatus: string;
  scheduledByUserId: string;
  scheduledFromApp: string;
  slot: Slot;
  slotIds: string[];
  specialtyId: string;
  status: string;
  statusTimes: {Upcoming: number};
  thatDayNotification: string;
  titl: string;
  totalDuration: number;
  virtual: boolean;
  visitId?: string;
  visitSummaryPushStatus: string;
  waivePatientResponsibility: boolean;
};

type AppointmentResponsibleParty = {
  apptId: string;
  createdAt: number;
  id: string;
  typ: string;
};

type AppointmentSpecialty = {
  createdAt: number;
  examEntityId: string;
  id: string;
  isDefault: boolean;
  isPrimaryCare: boolean;
  isUrgentCare: boolean;
  isVirtual: boolean;
  fullName: string;
  name: string;
  legacyCode: string;
  placeOfServiceCode: string;
  popular: boolean;
  requiresCompletedApptFlow: boolean;
  shortDescription: string;
  sortIndex: number;
  status: string;
  taxonomyCode: string;
};

type Slot = {
  allowHouseCall: boolean;
  allowVirtual: boolean;
  apptId: string;
  confirmed: boolean;
  createdAt: number;
  deleted: boolean;
  doctorId: string;
  duration: number;
  id: string;
  locationId: string;
  specialtyIds: string[];
  time: number;
  walkInOnly: boolean;
};
